import React from "react";
import PopupModules from "src/features/auth/components/PopupModules";
import { Order } from "src/shared/services/interface";
import { useUser } from "../../components/UserContext";
import { SlidbarThemeStyles, themeStyles } from "src/shared/services/themes";
// import { Button } from "../../components/Button";

interface Props {
  open: boolean;
  close: () => void;
  order: Order;
}

export const formatAmount = (val: any) => {
  const num = Number(val);
  if (isNaN(num)) return "check in ledger";

  return Math.abs(num) < 0.01 ? "0.00" : num.toFixed(2);
};

function PaymentHistory({ open, close, order }: Props) {
  const { user } = useUser();

  return (
    <PopupModules isOpen={open} onClose={close} title='Selected Order Payment History' className='w-[60%] max-h-[80vh] overflow-auto'>
      <div className={`w-full`}>
        <div className={`flex justify-between items-center ${themeStyles[user?.background_colour || 0]} rounded-md shadow-sm p-2 mb-2 text-sm`}>
          <div className='w-1/12 text-center font-semibold'>#</div>
          <div className='w-3/12 text-start'>Date</div>
          <div className='w-3/12'>Method</div>
          <div className='w-2/12 text-end'>Received</div>
          <div className='w-2/12 text-end'>Adjustment</div>
          <div className='w-2/12 text-end'>Refund</div>
          <div className='w-2/12 text-end'>Balance</div>
        </div>
        {order?.paymentHistory?.length ? (
          order.paymentHistory.map((p, index) => (
            <div
              key={index}
              className={`flex justify-between items-center ${SlidbarThemeStyles[user?.background_colour || 0]
                } rounded-md shadow-sm p-2 mb-2 text-sm`}
            >
              <div className='w-1/12 text-center font-semibold'>{index + 1}</div>
              <div className='w-3/12 text-start'>{p.date ?? p.payment_on}</div>
              <div className='w-3/12 text-start'>{p.Paymentmethod}</div>
              <div className='w-2/12 text-end'>{Number(p.ReceivedAmount).toFixed(2)}</div>
              <div className='w-2/12 text-end'>{Number(p.adjustAmount || 0).toFixed(2)}</div>
              <div className='w-2/12 text-end'>{Number(p.refundAmount || 0).toFixed(2)}</div>
              <div className='w-2/12 text-end'>{formatAmount(p.balance)}</div>
            </div>
          ))
        ) : (
          <p className='text-center text-gray-600'>No payment history available.</p>
        )}

        {/* {bug ticket 1448} */}
        {/* <div className='w-full h-fit p-1 flex justify-center gap-4'>
          <Button label='Close' variant='cancel' onClick={close} />
          <Button label='Print History' variant='ThemeBase' onClick={() => printHistory("History")} />
        </div> */}
      </div>
    </PopupModules>
  );
}

export default PaymentHistory;
